import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { TableService } from '@pg-app/partner/dashboard/components/table/table.service';
import { format } from 'date-fns';
import { ToastrService } from 'ngx-toastr';
import { UtilityService } from '@nttp/common-service/utility-service';
import { TableCellTypes } from '@nttp/enum/table-cell-type-enum';
import { SortTypeEnum } from '@pg-app/shared/enums/sort-type.enum';
import { DATE_FORMAT_POST, MONTH_NAMES } from '../constants/date-time-constants';


@Component({
  selector: 'np-table-monthly-commision',
  templateUrl: './monthly-commision.component.html',
  styleUrls: ['./monthly-commision.component.scss']
})
export class TableMonthlyCommisionComponent implements OnInit, OnChanges {
  @Input()
  filter: any;

  public rows: Array<any> = [];
  public searchForm: FormGroup;
  public totalCommission: String = '';

  columns = [
    {
      title: 'Client Name',
      name: 'clientName',
      width: '200px'
    },
    {
      title: 'Transaction Size',
      name: 'currencyCodeTransactionSize',
      width: '200px',
      class: 'amount-align'
    },
    {
      title: 'Commission',
      name: 'commission',
      width: '200px',
      class: 'amount-align'
    },
    {
      title: 'Date Referred',
      name: 'dateReferred',
      type: TableCellTypes.Date,
      width: '200px'
    },
    {
      title: 'Date Traded',
      name: 'dateTraded',
      type: TableCellTypes.Date,
      width: '200px'
    }
  ];

  constructor(
    private fb: FormBuilder,
    private toasterService: ToastrService,
    private tableService: TableService,
    private utilityService: UtilityService
  ) { }

  ngOnInit() {
    this.searchForm = this.fb.group({
      fromDate: '',
      toDate: ''
    });
  }

  ngOnChanges() {
    if (this.filter) {
      const month = MONTH_NAMES.indexOf(this.filter.month);
      const start = new Date(this.filter.year, month, 1);
      this.searchForm.get('fromDate').setValue(start);
      const end = new Date(this.filter.year, month + 1, 0);
      this.searchForm.get('toDate').setValue(end);

      this.getTableData();
      this.getTotalCommission();
    }
  }

  public getTableData() {
    const tableData = {
      getAll: true,
      fromDate: format(this.searchForm.get('fromDate').value, DATE_FORMAT_POST),
      toDate: format(this.searchForm.get('toDate').value, DATE_FORMAT_POST),
      sortName: 'DateTraded',
      sortType: SortTypeEnum.Desc
    };

    this.tableService.getTableCommissionData(tableData).subscribe(
      data => {
        data = data || [];
        if (data.length > 0) {
          data.forEach(item => {
            item.commission = Number(item.commissionGBP) >= 0
              ? `GBP ${this.utilityService.replaceValue(item.commissionGBP)}`
              : `GBP (${this.utilityService.replaceValue(item.commissionGBP * -1)})`;
            item.currencyCodeTransactionSize = `${item.commissionCurrencyCode} ${this.utilityService.replaceValue(item.transactionSize)}`;
          });
        }
        this.rows = data;
      },
    );
  }

  public getSearchData() {
    if (new Date(this.searchForm.get('fromDate').value) > new Date(this.searchForm.get('toDate').value)) {
      this.toasterService.error(`From date should not be greater than To date`);
      return;
    }

    this.getTableData();
    this.getTotalCommission();
  }

  public getTotalCommission() {
    const fromDate = format(this.searchForm.get('fromDate').value, DATE_FORMAT_POST);
    const toDate = format(this.searchForm.get('toDate').value, DATE_FORMAT_POST);

    this.tableService.getTotalCommissionData(fromDate, toDate).subscribe(data => {
      this.totalCommission = data;
    });
  }
}
